/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-08-03 14:55:45
 *
 *******************************************************/
// @flow

import React from 'react';
import { Banner, TextStyle } from '@shopify/polaris';
import { withI18n } from '@shopify/react-i18n';

import history from 'src/routes/history';
import { routes } from 'src/routes';

// DONE
const SortByManualBanner = props => {
  const { i18n, themeSetupV2 = false } = props;

  const goToSettingSortBy = () => {
    if (themeSetupV2) {
      history.push({ pathname: routes.customSorting.view(), state: { selectedTab: 0 } });
      return;
    }
    history.push({ pathname: routes.filterSettings.view(), state: { selectedTab: 1 } });
  };
  return (
    <Banner
      title={i18n.translate('AdminHTML.MerchandisingV2.SortByManual.bannerTitle')}
      status="critical"
      action={{
        content: i18n.translate('AdminHTML.MerchandisingV2.SortByManual.bannerAction', {
          manual: (
            <strong style={{ marginLeft: 3 }}>
              {i18n.translate('AdminHTML.MerchandisingV2.SortByManual.manual')}
            </strong>
          )
        }),
        onAction: () => goToSettingSortBy()
      }}>
      <p>
        {i18n.translate('AdminHTML.MerchandisingV2.SortByManual.bannerContent', {
          manual: (
            <TextStyle variation="strong">
              {i18n.translate('AdminHTML.MerchandisingV2.SortByManual.manual')}
            </TextStyle>
          ),
          relevance: (
            <TextStyle variation="strong">
              {i18n.translate('AdminHTML.MerchandisingV2.SortByManual.relevance')}
            </TextStyle>
          )
        })}
      </p>
    </Banner>
  );
};

export default withI18n()(SortByManualBanner);
